import { Component, inject, signal } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { GlobalHeaderComponent } from './shared/global-header/global-header.component';

@Component({
    selector: 'pims-root',
    imports: [RouterOutlet, GlobalHeaderComponent],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    private readonly router = inject(Router);
    private readonly translate = inject(TranslateService);
    protected readonly isMobileRoute = signal(
        typeof window !== 'undefined' && window.location.pathname.startsWith('/mobile'),
    );
    protected readonly title = signal('ProductInventoryManagementSystem');

    constructor() {
        this.translate.addLangs(['en']);
        this.translate.setFallbackLang('en');

        this.router.events
            .pipe(
                filter(
                    (event): event is NavigationStart | NavigationEnd =>
                        event instanceof NavigationStart || event instanceof NavigationEnd,
                ),
            )
            .subscribe((event) => {
                const url = event instanceof NavigationEnd ? event.urlAfterRedirects : event.url;
                this.isMobileRoute.set(url.startsWith('/mobile'));
            });
    }
}
